import { CardActions, CardHeader } from '@mui/material';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import React, { useState } from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import { FileMappingIcon } from '../../ui-parts/FileMappingIcon';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import TooltipLabel from '../../ui-parts/TooltipLabel';
import { utility } from '../../utility';
import { MyMTooltip } from '../../ui-elements/MyMToolTip'
import { IconButton } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

export const HomeNoContentBox = ({ content }) => {
  return (
    <Box sx={{ padding: "10px" }}>
      <MyMLabel>{content}</MyMLabel>
    </Box>
  )
}

export const HomeLeftHeader = ({ title, paddingTop, ...other }) => {
  const HeaderStyle = {
    paddingBottom: "0px",
    paddingLeft: "10px",
    paddingTop: { paddingTop }
  }
  return (
    <CardHeader title={title} titleTypographyProps={{ fontSize: '1rem', align: 'left', fontWeight: 'bold' }} style={HeaderStyle} {...other}></CardHeader >
  )
}

export const HomeFileListItem = ({ screenId, fileId, uploadDate, fileName, fileNameAbbMaxLength, extension, onPreview }) => {

  const ellipsisFileName = utility.convertEllipsisFormat(fileName ?? '', fileNameAbbMaxLength);
  const isPc = useMediaQuery(mediaQuery.pc);
  const [tooltipState, setTooltipState] = useState({});
  const handleTooltipToggle = (fileId) => {
    setTooltipState((prevState) => ({
      ...prevState,
      [fileId]: !prevState[fileId],
    }));
  };
  return (
    <CardActions sx={{ padding: "8px 8px" }}>
      <ListItem disablePadding sx={{ minHeight: "30px" }}>
          <FileMappingIcon screenId={screenId} extension={extension} width="25px" height="25px" />
          <MyMBlackLink onClick={(e) => { onPreview(e, fileId) }} sx={{ "marginLeft": "10px", textAlign: "left" }}>

            <TooltipLabel toolTipValue={ellipsisFileName !== fileName ? fileName : ''} value={uploadDate ? `${uploadDate} - ${ellipsisFileName}` : `${ellipsisFileName}`} />

          </MyMBlackLink>

          {!isPc && fileName !== ellipsisFileName &&
            <MyMTooltip
              title={fileName}
            arrow
            open={tooltipState[fileId] || false} // Tooltipの表示状態を制御
              onClose={() => handleTooltipToggle(fileId)} // Tooltipを閉じる
              onOpen={() => handleTooltipToggle(fileId)} // Tooltipを開く
            >
              <IconButton sx={{ marginLeft: "10px" }} onClick={() => handleTooltipToggle(fileId)}>
                <PendingIcon sx={{ width: '20px' }} />
              </IconButton>
            </MyMTooltip>
              }
      </ListItem>
    </CardActions>
  )
}

export const HomeMorePageLink = ({ listData, href, displayContent ,state}) => {
  return (
    listData.length > 0 &&
    <CardActions sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
      <NavigateLink to={href} underline="hover" sx={{ color: "#60AEE1" }} navigateState={state} >
        {displayContent}
      </NavigateLink>
    </CardActions >
  )
}

export const HomeCenterHeader = ({ title }) => {
  return (
    <CardHeader title={title} titleTypographyProps={{ fontSize: '1rem', align: 'center' }} sx={{
      backgroundColor: '#777', color: "white", padding: "10px 0px"
    }}>
    </CardHeader>
  )
}